import styled from 'styled-components';

const FooterStyle = styled.footer`
	--footerBorderRadius: var(--sp25x) var(--sp25x) 0 0;
	--footerPadding: var(--sp14x) 0;
	--subscribeTextMarginBottom: var(--sp4x);
	--socialItemMarginRight: var(--sp4x);
	--socialIconSize: var(--sp4x);
	--lowerFooterPaddingTop: var(--sp5x);
	--eventButtonMarginBottom: var(--sp3x);
	--footerFormInput: var(--sp48x);
	--footerFormPadding: var(--sp2x) var(--sp3x);
	--footerSubscribeButtonPadding: var(--sp2x) var(--sp3x);
	--footerFormSuccessMessagePaddingLeft: var(--sp3x);
	--footerFormSuccessMessageMarginTop: var(--sp0-5x);

	--colTitleMarginBottom: var(--sp4x);
	--subscribeBlockImagePaddingTop: 25%;

	--subscribeBlockImageWidth: 60%;

	border-radius: var(--footerBorderRadius);

	.footer-inner-wrapper {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: var(--footerFormPadding);
		background-color: var(--primaryColor3);
		border-radius: var(--sp1x);
	}

	.hidden-track-link {
		display: inline-block;
		width: fit-content;
	}

	.col-title {
		margin-bottom: var(--colTitleMarginBottom);
	}

	.subscribe-block-image {
		width: var(--subscribeBlockImageWidth);
		margin-top: var(--subscribeTextMarginBottom);

		.imageCont {
			--imagePaddingTop: var(--subscribeBlockImagePaddingTop);
		}
	}

	.visit-link {
		display: block;
		width: fit-content;
	}

	.subscribe-block-committee {
		display: block;
		width: fit-content;
	}

	.footer-form-success-message {
		position: absolute;
		top: 100%;
		left: 0;
		padding-left: var(--footerFormSuccessMessagePaddingLeft);
		margin-top: var(--footerFormSuccessMessageMarginTop);
	}

	.more-footer-links {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		justify-content: flex-end;
		width: 100%;

		.events-button {
			margin-bottom: var(--eventButtonMarginBottom);
		}
	}

	.footer-content-wrap {
		display: flex;
		padding: var(--footerPadding);

		.subscribe-block {
			width: 100%;

			.form-wrap {
				position: relative;

				.ant-form-item-explain {
					width: 100%;
					padding-left: unset;
					position: absolute;
					margin-top: calc(var(--p) - var(--sp0-5x));
				}

				.footer-form-input {
					width: var(--footerFormInput);
				}

				.footer-form {
					&.sending {
						pointer-events: none;
					}

					.ant-input {
						border: none;
						background-color: transparent;
						padding: unset;
					}

					.footer-btn {
						button {
							padding: var(--footerSubscribeButtonPadding);
							border-radius: var(--sp1x);

							span {
								font-size: var(--pS);
								font-family: var(--ping);
								font-weight: 700;
							}
						}
					}

					.ant-form-item {
						margin: 0;
					}
				}
			}

			.subscribe-block-text {
				margin-bottom: var(--subscribeTextMarginBottom);
			}

			.subscribe-block-socials {
				.socials-item {
					margin-right: var(--socialItemMarginRight);

					.social-icon {
						transition: var(--trTime);
						font-size: var(--socialIconSize);

						@media (hover: hover) {
							&:hover {
								color: var(--primaryColor2);
							}
						}
					}

					&:last-child {
						margin-right: 0;
					}
				}
			}
		}
	}

	.line {
		height: 1px;
		background-color: var(--secondaryColor2);
		opacity: 20%;
	}

	.lower-footer {
		padding-top: var(--lowerFooterPaddingTop);

		.copyright-wrap {
			display: flex;
		}

		.lower-footer-text-content-wrap {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.made-by-wrap {
				display: flex;
			}
		}
	}

	.footer-center-wrapper {
		.ft-center-item {
			display: flex;
			align-items: flex-start;
			justify-content: space-between;

			.ft-col-50 {
				width: calc(50% - var(--colPadding));
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--footerBorderRadius: var(--sp25x) var(--sp25x) 0 0;
		--footerPadding: var(--sp10x) 0;
		--subscribeTextMarginBottom: var(--sp4x);
		--socialItemMarginRight: var(--sp3x);
		--socialIconSize: var(--sp3x);
		--lowerFooterPaddingTop: var(--sp4x);
		--eventButtonMarginBottom: var(--sp2x);
		--footerFormInput: var(--sp35x);
		--footerFormPadding: var(--sp1-5x) var(--sp2x);
		--footerSubscribeButtonPadding: var(--sp1-5x) var(--sp2x);
		--footerFormSuccessMessagePaddingLeft: var(--sp2x);
		--footerFormSuccessMessageMarginTop: var(--sp1x);
		--colTitleMarginBottom: var(--sp3x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--footerBorderRadius: var(--sp20x) var(--sp20x) 0 0;
		--footerPadding: var(--sp8x) 0;
		--subscribeTextMarginBottom: var(--sp3x);
		--socialItemMarginRight: var(--sp2-5x);
		--socialIconSize: var(--sp2-5x);
		--lowerFooterPaddingTop: var(--sp3x);
		--eventButtonMarginBottom: var(--sp3x);
		--footerFormInput: var(--sp25x);
		--footerFormPadding: var(--sp1-5x) var(--sp2x);
		--footerSubscribeButtonPadding: var(--sp1x) var(--sp1-5x);
		--footerFormSuccessMessagePaddingLeft: var(--sp2x);
		--footerFormSuccessMessageMarginTop: var(--sp1-5x);
		--colTitleMarginBottom: var(--sp2-5x);

		--subscribeBlockImageWidth: 70%;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--footerBorderRadius: var(--sp20x) var(--sp20x) 0 0;
		--footerPadding: var(--sp8x) 0;
		--subscribeTextMarginBottom: var(--sp4x);
		--socialItemMarginRight: var(--sp2-5x);
		--socialIconSize: var(--sp2-5x);
		--lowerFooterPaddingTop: var(--sp3x);
		--eventButtonMarginBottom: var(--sp2x);
		--footerFormInput: var(--sp25x);
		--footerFormPadding: var(--sp1x) var(--sp1-5x);
		--footerSubscribeButtonPadding: var(--sp1x) var(--sp1-5x);
		--footerFormSuccessMessagePaddingLeft: var(--sp1-5x);
		--footerFormSuccessMessageMarginTop: var(--sp1x);
		--colTitleMarginBottom: var(--sp2-5x);

		--subscribeBlockImageWidth: 70%;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--footerBorderRadius: var(--sp14x) var(--sp14x) 0 0;
		--footerPadding: var(--sp8x) 0;
		--subscribeTextMarginBottom: var(--sp3x);
		--socialItemMarginRight: var(--sp2-5x);
		--socialIconSize: var(--sp2-5x);
		--lowerFooterPaddingTop: var(--sp3x);
		--eventButtonMarginBottom: var(--sp2x);
		--footerFormInput: var(--sp25x);
		--footerFormPadding: var(--sp1x) var(--sp1-5x);
		--footerSubscribeButtonPadding: var(--sp1x) var(--sp1-5x);
		--footerFormSuccessMessagePaddingLeft: var(--sp1-5x);
		--footerFormSuccessMessageMarginTop: var(--sp1x);
		--colTitleMarginBottom: var(--sp2-5x);

		--subscribeBlockImageWidth: 23.5%;

		.subscribe-block {
			.form-wrap {
				max-width: 75.3%;
			}
		}

		.sb-center-block {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: var(--sp4x);
		}

		.subscribe-block-image {
			margin-top: 0 !important;
		}

		.weather-block {
			width: var(--subscribeBlockImageWidth);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--footerBorderRadius: var(--sp17x) var(--sp17x) 0 0;
		--footerPadding: var(--sp8x) 0;
		--subscribeTextMarginBottom: var(--sp3x);
		--socialItemMarginRight: var(--sp2-5x);
		--socialIconSize: var(--sp2-5x);
		--lowerFooterPaddingTop: var(--sp3x);
		--footerFormInput: var(--sp25x);
		--footerFormPadding: var(--sp1x) var(--sp1-5x);
		--footerSubscribeButtonPadding: var(--sp1x) var(--sp1-5x);
		--footerFormSuccessMessagePaddingLeft: var(--sp1-5x);
		--footerFormSuccessMessageMarginTop: var(--sp1x);
		--colTitleMarginBottom: var(--sp2-5x);

		--subscribeBlockImageWidth: 28.2%;

		.subscribe-block {
			.form-wrap {
				max-width: 74.7%;
			}
		}

		.sb-center-block {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: var(--sp4x);
		}

		.subscribe-block-image {
			margin-top: 0 !important;
		}

		.weather-block {
			width: var(--subscribeBlockImageWidth);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--footerBorderRadius: var(--sp17x) var(--sp17x) 0 0;
		--footerPadding: var(--sp8x) 0;
		--subscribeTextMarginBottom: var(--sp3x);
		--socialItemMarginRight: var(--sp2-5x);
		--socialIconSize: var(--sp2-5x);
		--lowerFooterPaddingTop: var(--sp3x);
		--footerFormInput: var(--sp25x);
		--footerFormPadding: var(--sp1x) var(--sp1-5x);
		--footerSubscribeButtonPadding: var(--sp1x) var(--sp1-5x);
		--footerFormSuccessMessagePaddingLeft: var(--sp1-5x);
		--footerFormSuccessMessageMarginTop: var(--sp1x);
		--colTitleMarginBottom: var(--sp2-5x);

		--subscribeBlockImageWidth: 60.8%;

		.subscribe-block-image {
			width: var(--subscribeBlockImageWidth);
			margin-top: var(--sp5x);
		}

		.weather-block {
			width: 75%;
			margin-top: var(--sp5x);
		}

		.more-footer-links {
			margin-bottom: var(--sp5x);
			align-items: flex-start;
		}

		.lower-footer {
			.lower-footer-text-content-wrap {
				flex-direction: column;
				justify-content: flex-start;
				align-items: flex-start;

				.copyright-wrap {
					margin-bottom: var(--sp3x);
				}

				.made-by-wrap {
					margin-bottom: var(--sp5x);
				}
			}
		}

		.ft-tablet-right-top {
			> p {
				margin-bottom: var(--sp2-5x);
			}

			> a {
				margin-top: var(--sp1-5x);
			}

			.media-library-button {
				margin-top: var(--sp2-5x);
			}
		}

		.ft-tablet-right-bottom {
			margin-top: var(--sp5x);

			.subscribe-block-socials,
			.subscribe-block-hashtag {
				margin-top: var(--sp3x);
			}
		}
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--footerBorderRadius: var(--sp8x) var(--sp8x) 0 0;
		--footerPadding: var(--sp7x) 0;
		--subscribeTextMarginBottom: var(--sp3x);
		--socialItemMarginRight: var(--sp2x);
		--socialIconSize: var(--sp2x);
		--lowerFooterPaddingTop: var(--sp3x);
		--footerFormInput: var(--sp25x);
		--footerFormPadding: var(--sp1x) var(--sp1-5x);
		--footerSubscribeButtonPadding: var(--sp1x) var(--sp1-5x);
		--footerFormSuccessMessagePaddingLeft: var(--sp1-5x);
		--footerFormSuccessMessageMarginTop: var(--sp1x);
		--colTitleMarginBottom: var(--sp2x);

		--subscribeBlockImageWidth: 50%;

		.more-footer-links {
			margin-bottom: var(--sp5x);
			align-items: flex-start;
		}

		.lower-footer {
			.lower-footer-text-content-wrap {
				flex-direction: column;
				justify-content: flex-start;
				align-items: flex-start;

				.copyright-wrap {
					margin-bottom: var(--sp3x);
				}

				.made-by-wrap {
					margin-bottom: var(--sp3x);
				}
			}
		}

		.col-m-12 {
			&:not(:first-child) {
				margin-top: var(--sp4x);
			}
		}

		.subscribe-block-image {
			width: var(--subscribeBlockImageWidth);
		}

		.weather-block {
			margin-top: var(--sp4x);
		}
	}
`;

export default FooterStyle;
